export const subdomains = [
  {
    url: "speed.aussiebroadband.com.au",
    baseUrl: "/speed",
  },
];

export const subdomainMap = new Map(subdomains.map((i) => [i.url, i]));
